import { useMemo } from "react";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { isAcceptableToDrop } from "../Helpers/droppableAcceptsDraggable";

export const useVisibleDropZones = () => {
  const dropZonePositions = useBuilderStore(state => state.dropZonePositions);
  const draggingTemplate = useBuilderStore(state => state.draggingTemplate);

  return useMemo(() => {
    if (!draggingTemplate) return [];

    const categories = draggingTemplate.meta.category ?? [];
    return dropZonePositions.filter(position =>
      isAcceptableToDrop({
        accepts: position.accepts,
        rejects: position.rejects,
        categories,
      }),
    );
  }, [dropZonePositions, draggingTemplate]);
};
